export function removeTrailingSlash(input: string): string {
  if (input.endsWith("/")) {
    return input.slice(0, -1);
  }
  return input;
}

export function buildProductUrl(baseUrl: string, slug: string): string {
  // Remove API endpoints from baseUrl and get the clean domain
  // e.g., https://example.com/wp-json/wc/v3 -> https://example.com
  const cleanBaseUrl = baseUrl.replace(/\/wp-json.*$/, "");

  // Ensure baseUrl doesn't end with slash and slug doesn't start with slash
  const cleanedBaseUrl = removeTrailingSlash(cleanBaseUrl);
  const cleanedSlug = slug.startsWith("/") ? slug.slice(1) : slug;

  return `${cleanedBaseUrl}/${cleanedSlug}`;
}
